(ns app.front.view.group.admin.fees.reversal-methods.core
  (:require [app.domain.fee.model :as fee-model]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.view.group.admin.fees.reversal-methods.events :as rm-events]
            [app.front.view.group.admin.fees.reversal-methods.form :as rm-form]
            [app.front.view.group.admin.fees.reversal-methods.subs :as rm-subs]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::init
  (fn [{db :db} [_ group-id]]
    {:db       (assoc-in db [::group-admin :fees :reversal-methods :group-id] group-id)
     :dispatch [::rm-events/fetch-reversal-methods group-id]}))

(defn reversal-methods-list [tr]
  #_{:clj-kondo/ignore [:deprecated-var]}
  (let [methods     (<sub [::rm-subs/methods])
        expanded-id (<sub [::rm-subs/expanded-method-id])
        adding-new? (<sub [::rm-subs/adding-new?])
        lang        (<sub [:language])]
    [:div.flex.flex-col.gap-2.bg-ui-white.p-4.mt-6
     [:h2.text-xl.font-bold (tr [:fees/reversal-methods])]
     [ui-table/table-2
      {:id                "reversal-methods-table"
       :items             (cond-> methods
                            adding-new? (concat [{:db/id :new}]))
       :header+extractors [[:fee.reversal-method/name
                            (fn [method]
                              (if (= (:db/id method) :new)
                                (tr [:fee.reversal-method/new-method])
                                (fee-model/reversal-method-title method lang)))]
                           [:fee.reversal-method/type
                            (fn [method]
                              (when-not (= (:db/id method) :new)
                                (tr [(:bill-reversal-method/type method)])))]
                           [:fee.reversal-method/notification-message
                            (fn [method]
                              (when-not (= (:db/id method) :new)
                                (fee-model/reversal-method-message method lang)))]]
       :expand-component  (fn [method _]
                            [rm-form/inline-editor tr (:db/id method)])
       :expanded?         (fn [method]
                            (= expanded-id (:db/id method)))
       :on-expand         (fn [method]
                            (>evt [::rm-events/expand-method method]))
       :row-class         (fn [method]
                            (when (and (not= (:db/id method) :new)
                                       (fee-model/reversal-method-disabled? method))
                              "opacity-50 bg-gray-100"))
       :tr                tr}]
     [ui/button {:kind     :secondary
                 :icon     i/plus
                 :on-click #(>evt [::rm-events/add-new-method])}
      (tr [:fee.reversal-method/add-method])]]))

(defn view [tr]
  [reversal-methods-list tr])
